/* eslint-disable no-console */
import { useCallback, useEffect, useRef, useState } from 'preact/hooks';

import { useWidget } from '../context/WidgetContext';
import { storageManager } from '../utils';

import { LAST_SEEN_MESSAGE_ID } from '../constants/localStorage';

export const useMessagesTracking = () => {
  const { messages } = useWidget();
  const [lastSeenId, setLastSeenId] = useState<string | null>(null);
  const listRef = useRef<HTMLDivElement>(null);

  // Читаем ID последнего просмотренного сообщения при монтировании
  useEffect(() => {
    try {
      const savedLastSeenId = storageManager?.getItem(LAST_SEEN_MESSAGE_ID);
      if (savedLastSeenId) {
        setLastSeenId(savedLastSeenId);
      }
    } catch (error) {
      console.error('Error loading last seen ID from storage:', error);
    }
  }, []);

  // Сохраняем ID последнего просмотренного сообщения при изменении
  useEffect(() => {
    try {
      if (lastSeenId) {
        storageManager?.setItem(LAST_SEEN_MESSAGE_ID, lastSeenId);
      }
    } catch (error) {
      console.error('Error saving last seen ID to storage:', error);
    }
  }, [lastSeenId]);

  // Колбэк IntersectionObserver для отслеживания видимых сообщений
  const handleIntersection = useCallback((entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const messageId = entry.target.getAttribute('data-id');
        if (messageId) {
          setLastSeenId(messageId);
        }
      }
    });
  }, []);

  // Подключаем IntersectionObserver к элементам сообщений
  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      root: listRef.current,
      threshold: 0.5, // сообщение считается просмотренным при видимости на 50%
    });

    const messageElements = listRef.current?.querySelectorAll('[data-message]');
    messageElements?.forEach((el) => observer.observe(el));

    return () => {
      messageElements?.forEach((el) => observer.unobserve(el));
    };
  }, [messages, handleIntersection]);

  return { listRef };
};
